var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"container flex-center relative z-10"},[_c('h1',{staticClass:"header-title"},[_c('span',{staticClass:"top-line"}),_c('i',{staticClass:"ml-2 text-white text-opacity-80",class:_vm.icon}),_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"bottom-line"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }